import _ from 'lodash'
import parse from 'html-react-parser'

import { format } from 'date-fns'
import { formatInTimeZone } from "date-fns-tz"




export const buildAgenda = (sessionsData) => {

    if ( !sessionsData ) return 
    
    const timeslots = _.groupBy(sessionsData, 'beginsAt')
    

    // calculate event days

    function getUniqueDays ( sessionData ) {
        const groupedStartTimes = _.groupBy(sessionData, 'beginsAt')
        const timeCodes = Object.keys(groupedStartTimes)
        const eventDays = _.uniqBy( timeCodes, string => string.slice(0, 10) )	
        return eventDays
    }
    
    const agendaDays = []
    getUniqueDays( sessionsData ).map((timestring, index) => {
        agendaDays.push({ 
            day: format( new Date(timestring), "eeee dd MMMM" ), 
            time: timestring.slice(0, 10), 
            timeslots: [] 
        })
    })

    // console.log('agendaDays:', agendaDays)


    // add filters here +++++++++++


    // build agenda

    const agenda = []
    agendaDays.map( day => {
        let slots = []
        for ( const key in timeslots ) {
            if ( key.slice(0, 10) === day.time.slice(0, 10) ) {
                slots.push({ 
                    beginsAt: timeslots[key][0].beginsAt, 
                    endsAt: timeslots[key][0].endsAt, 
                    sessions: timeslots[key]
                })
            }
        }

        agenda.push( { ...day , timeslots: slots } )
    })


    // console.log('agenda:', agenda)
    return agenda
}